export default "__VITE_ASSET__gIVF4thE__"